// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donutContainer_fcWhJ {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto;
}

.donutSvg_K_5c8 {
    position: absolute;
    top: 0;
    left: 0;
    overflow: unset;
}

.backgroundCircle_n1B0O {
    opacity: 0.3;
    transition: opacity 0.3s ease;
}

.progressCircle_opqP5 {
    transition: stroke-dashoffset 0.3s ease;
    filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
}

.progressCircle_opqP5.loading_eS5jA {
    animation: pulse___lAI 2s ease-in-out infinite;
}

@keyframes pulse___lAI {
    0% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
        stroke-width: 8px;
        opacity: 0.8;
    }

    50% {
        filter: drop-shadow(0 0 12px rgba(22, 192, 152, 0.8));
        stroke-width: 10px;
        opacity: 1;
    }

    100% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
        stroke-width: 8px;
        opacity: 0.8;
    }
}

.donutSvg_K_5c8.loading_eS5jA {
    animation: subtleRotate_w80Is 4s linear infinite;
}

@keyframes subtleRotate_w80Is {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.progressCircle_opqP5.transitioning_VgvMu {
    animation: transitionPulse_ixXoO 0.6s ease-in-out;
}


.endTime_KBcqg {
    margin: 24px 0px;
    height: unset !important;

    circle {
        display: none;
    }

    .timerText_WE5PJ {
        flex-direction: row;
        gap: 4px;
    }
}

@keyframes transitionPulse_ixXoO {
    0% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
        opacity: 1;
    }

    50% {
        filter: drop-shadow(0 0 8px rgba(22, 192, 152, 0.6));
        opacity: 0.8;
    }

    100% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
        opacity: 1;
    }
}

.timerText_WE5PJ {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 2;
}

.seconds_c2_TY {
    font-size: 2rem;
    font-weight: 700;
    color: #333;
    line-height: 1;
    margin: 0;
    font-family: 'Arial', sans-serif;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.unit_isfLO {
    font-size: 0.8rem;
    font-weight: 500;
    color: #666;
    margin-top: -2px;
    text-transform: uppercase;
    letter-spacing: 1px;
}



.controls_mPcjG {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.donutContainer_fcWhJ:hover .controls_mPcjG {
    opacity: 1;
}


.donutContainer_fcWhJ.small_oVOkL {
    transform: scale(0.7);
}

.donutContainer_fcWhJ.large_pRSB_ {
    transform: scale(1.3);
}

.donutContainer_fcWhJ.completed_AP5gD .progressCircle_opqP5 {
    animation: completePulse_AW7BA 1s ease-in-out;
}

@keyframes completePulse_AW7BA {
    0% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
    }

    50% {
        filter: drop-shadow(0 0 12px rgba(22, 192, 152, 0.8));
    }

    100% {
        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));
    }
}

.donutContainer_fcWhJ.paused_bXJWb .progressCircle_opqP5 {
    opacity: 0.7;
    animation: none;
}

@media (max-width: 768px) {
    .seconds_c2_TY {
        font-size: 1.5rem;
    }

    .unit_isfLO {
        font-size: 0.7rem;
    }

    .controls_mPcjG {
        bottom: -35px;
    }


}

@media (prefers-color-scheme: dark) {
    .seconds_c2_TY {
        color: #fff;
    }

    .unit_isfLO {
        color: #ccc;
    }


}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/DonutTimer/DonutTimer.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,oDAAoD;AACxD;;AAEA;IACI,8CAAwC;AAC5C;;AAEA;IACI;QACI,oDAAoD;QACpD,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,qDAAqD;QACrD,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,oDAAoD;QACpD,iBAAiB;QACjB,YAAY;IAChB;AACJ;;AAEA;IACI,gDAA0C;AAC9C;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,iDAA2C;AAC/C;;;AAGA;IACI,gBAAgB;IAChB,wBAAwB;;IAExB;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,oDAAoD;QACpD,UAAU;IACd;;IAEA;QACI,oDAAoD;QACpD,YAAY;IAChB;;IAEA;QACI,oDAAoD;QACpD,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,SAAS;IACT,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;;;AAIA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6CAAuC;AAC3C;;AAEA;IACI;QACI,oDAAoD;IACxD;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,oDAAoD;IACxD;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;;AAGJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;;AAGJ","sourcesContent":[".donutContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 30px auto;\n}\n\n.donutSvg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: unset;\n}\n\n.backgroundCircle {\n    opacity: 0.3;\n    transition: opacity 0.3s ease;\n}\n\n.progressCircle {\n    transition: stroke-dashoffset 0.3s ease;\n    filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n}\n\n.progressCircle.loading {\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n        stroke-width: 8px;\n        opacity: 0.8;\n    }\n\n    50% {\n        filter: drop-shadow(0 0 12px rgba(22, 192, 152, 0.8));\n        stroke-width: 10px;\n        opacity: 1;\n    }\n\n    100% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n        stroke-width: 8px;\n        opacity: 0.8;\n    }\n}\n\n.donutSvg.loading {\n    animation: subtleRotate 4s linear infinite;\n}\n\n@keyframes subtleRotate {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.progressCircle.transitioning {\n    animation: transitionPulse 0.6s ease-in-out;\n}\n\n\n.endTime {\n    margin: 24px 0px;\n    height: unset !important;\n\n    circle {\n        display: none;\n    }\n\n    .timerText {\n        flex-direction: row;\n        gap: 4px;\n    }\n}\n\n@keyframes transitionPulse {\n    0% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n        opacity: 1;\n    }\n\n    50% {\n        filter: drop-shadow(0 0 8px rgba(22, 192, 152, 0.6));\n        opacity: 0.8;\n    }\n\n    100% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n        opacity: 1;\n    }\n}\n\n.timerText {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    z-index: 2;\n}\n\n.seconds {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #333;\n    line-height: 1;\n    margin: 0;\n    font-family: 'Arial', sans-serif;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.unit {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #666;\n    margin-top: -2px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n\n\n.controls {\n    position: absolute;\n    bottom: -40px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 8px;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.donutContainer:hover .controls {\n    opacity: 1;\n}\n\n\n.donutContainer.small {\n    transform: scale(0.7);\n}\n\n.donutContainer.large {\n    transform: scale(1.3);\n}\n\n.donutContainer.completed .progressCircle {\n    animation: completePulse 1s ease-in-out;\n}\n\n@keyframes completePulse {\n    0% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n    }\n\n    50% {\n        filter: drop-shadow(0 0 12px rgba(22, 192, 152, 0.8));\n    }\n\n    100% {\n        filter: drop-shadow(0 0 4px rgba(22, 192, 152, 0.3));\n    }\n}\n\n.donutContainer.paused .progressCircle {\n    opacity: 0.7;\n    animation: none;\n}\n\n@media (max-width: 768px) {\n    .seconds {\n        font-size: 1.5rem;\n    }\n\n    .unit {\n        font-size: 0.7rem;\n    }\n\n    .controls {\n        bottom: -35px;\n    }\n\n\n}\n\n@media (prefers-color-scheme: dark) {\n    .seconds {\n        color: #fff;\n    }\n\n    .unit {\n        color: #ccc;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"donutContainer": `donutContainer_fcWhJ`,
	"donutSvg": `donutSvg_K_5c8`,
	"backgroundCircle": `backgroundCircle_n1B0O`,
	"progressCircle": `progressCircle_opqP5`,
	"loading": `loading_eS5jA`,
	"pulse": `pulse___lAI`,
	"subtleRotate": `subtleRotate_w80Is`,
	"transitioning": `transitioning_VgvMu`,
	"transitionPulse": `transitionPulse_ixXoO`,
	"endTime": `endTime_KBcqg`,
	"timerText": `timerText_WE5PJ`,
	"seconds": `seconds_c2_TY`,
	"unit": `unit_isfLO`,
	"controls": `controls_mPcjG`,
	"small": `small_oVOkL`,
	"large": `large_pRSB_`,
	"completed": `completed_AP5gD`,
	"completePulse": `completePulse_AW7BA`,
	"paused": `paused_bXJWb`
};
export default ___CSS_LOADER_EXPORT___;
